import FooterN from '@/app/eflayout/Footer';
import FooterV3 from '@/app/eflayout/FooterV3';
import GloBarTop from '@/app/eflayout/GloBar/GloBarTop';
import GloCart from '@/app/eflayout/GloCart';
import HeaderN from '@/app/eflayout/Header';
import HeaderV2 from '@/app/eflayout/HeaderV2';
import HeaderV3 from '@/app/eflayout/HeaderV3';
import BhStatCommonA from '@/appComps/BhStatCommonA';
import ErrorMonitoringCommon from '@/appComps/ErrorMonitoringCommon';
import RegionPopup from '@/components/Popups/RegionPopup';
import { useGlobal } from '@/utils/useGlobal';
import EcoCreditsWin from '@elem/compCommon/EcoCreditsWin';
import CheckInCountdown from '@elem/ui/ef-check-in-activities/CheckInCountdown';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import React, { FC, useEffect, useRef } from 'react';
import SignupPopupOut from '../Popups/SignupPopup/SignupPopupOut';
import BackToTop from './BackToTop';
import styles from './index.module.scss';
import { newHeaderLocales } from './newHeaderLocales';
import PathTracker from './PathTracker';

//const HeaderN: any = dynamic(() => import('@/app/eflayout/Header'), { ssr: true });
const HeaderO: any = dynamic(() => import('@/components/headerN/header'), { ssr: false });
const FooterO: any = dynamic(() => import('@/components/footerN/footer'), { ssr: false });

type PageLayout = {
    title?: string;
    children?: React.ReactNode;
    className?: string;
    style?: object;
    theme?: string;
    hideHeader?: boolean;
    hideFooter?: boolean;
    isNoFixed?: boolean;
    navChildren?: React.ReactNode;
    hideToTop?: boolean;
    gloBarObjectPage?: any;
};

const PageLayout: FC<PageLayout> = ({
    children,
    navChildren,
    theme = '',
    isNoFixed,
    hideHeader,
    hideFooter,
    hideToTop,
    gloBarObjectPage,
    className = '',
    ...ohterProps
}) => {
    const { textIdA1, headerList = {}, bottomList = {}, gloBarObject, globalTimestamp } = useGlobal();
    const headerVersion = headerList?.version;
    const footerVersion = bottomList?.version;

    // const isShowHeaderV2 = headerVersion === 'V2';
    // const isShowHeaderV3 = headerVersion === 'V3';
    const isShowHeaderV2 = ['V2', 'v3'].includes(headerVersion); // === 'V2';
    const isShowHeaderV3 = false; //headerVersion === 'V3';
    const router = useRouter();
    const { locale = 'us' } = router;
    const showNewHeader = newHeaderLocales.includes(locale);
    const headerRef = useRef<HTMLDivElement | null>(null);
    const gloBarObject2 = gloBarObjectPage || gloBarObject;

    const isShowFooterV2 = ['V1', 'V2', 'V3'].includes(footerVersion); // footerVersion === 'V2';
    const isShowFooterV3 = false; //footerVersion === 'V3';

    // 监控header高度 => 其他页面header变化（比如bar条close）之后，更新页面的sticky元素定位top值
    const updateHeaderHeight = () => {
        if (headerRef.current) {
            const height = headerRef.current.offsetHeight;
            console.log('height', height);
            document.documentElement.style.setProperty('--header-height', `${height}px`);
        }
    };

    // us、de特定页面加上弹窗
    //const allowedEcoCredits = React.useMemo(() => {
    //const { locale, pathname } = router;
    // 所有页面都加上： https://ecoflow.feishu.cn/wiki/PjvawV3BkiQQgukEgvUc8ftsnjf
    // // us、de特定页面加上弹窗
    // const allowedEcoCredits = React.useMemo(() => {
    //     const { locale, pathname } = router;

    //     // 定义各地区允许显示 EcoCredits 的页面路径
    //     const ecoCreditsConfig = {
    //         us: ['/delta-pro-3-portable-power-station', '/power-preparedness'],
    //         de: ['/vanlife-roadtrips', '/recreational-activities'],
    //     };

    //     // 检查当前地区和路径是否匹配
    //     const allowedPaths = ecoCreditsConfig[locale as keyof typeof ecoCreditsConfig];
    //     return !!allowedPaths?.includes(pathname);
    // }, [router]);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            updateHeaderHeight();
        }
    }, []);

    return (
        <div className={`${styles['pagelayout-bd']} page-layout ${isNoFixed ? 'ecoflow-isNoFixed' : ''} ${className}`} {...ohterProps}>
            {!hideHeader && (
                <div className={`ecoflow-frame-header header-${headerVersion}`} ref={headerRef}>
                    <RegionPopup />
                    <GloBarTop gloBarObject={gloBarObject2.__globar_top} />
                    {showNewHeader && (
                        <>
                            {!isShowHeaderV2 && !isShowHeaderV3 && <HeaderN headerList={headerList} />}
                            {isShowHeaderV2 && <HeaderV2 headerList={headerList} />}
                            {isShowHeaderV3 && <HeaderV3 headerList={headerList} locale={locale} />}
                        </>
                    )}
                    {!showNewHeader && <HeaderO />}
                </div>
            )}
            {navChildren}
            <section className="ecoflow-frame-main allContentContainer" id="allContentContainer" role="main">
                {children}
            </section>
            {!hideFooter && !showNewHeader && <FooterO theme={theme} />}
            {!hideFooter && showNewHeader && isShowFooterV2 && <FooterN bottomList={bottomList} theme={theme} />}
            {!hideFooter && isShowFooterV3 && (
                <FooterV3 locale={locale} navItems={bottomList?.detailList || []} theme={['black', 'white'].includes(theme) ? theme : 'black'} />
            )}
            {!['br', 'mx', 'cn', 'sa', 'tw'].includes(locale) && <EcoCreditsWin />}
            {!hideToTop && <BackToTop />}
            <GloCart />
            <CheckInCountdown />
            <BhStatCommonA systemTimestamp={globalTimestamp} textIdA1={textIdA1} />
            <SignupPopupOut />
            <PathTracker />
            <ErrorMonitoringCommon />
        </div>
    );
};

export default PageLayout;
